import React from 'react';

const LocationIconNew = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...rest}>
      <path d="M4.88604 3.97118L17.3061 9.00452C17.4444 9.06052 17.5613 9.15896 17.64 9.28565C17.7187 9.41235 17.7552 9.56076 17.7442 9.70951C17.7332 9.85826 17.6752 9.99967 17.5787 10.1134C17.4822 10.2271 17.352 10.3072 17.207 10.3423L12.3744 11.5103C12.1642 11.5611 11.9721 11.6688 11.8192 11.8217C11.6663 11.9746 11.5585 12.1667 11.5077 12.3769L10.3397 17.2096C10.3047 17.3546 10.2245 17.4847 10.1108 17.5812C9.99711 17.6778 9.85569 17.7357 9.70694 17.7467C9.55819 17.7578 9.40978 17.7213 9.28309 17.6426C9.1564 17.5638 9.05796 17.4469 9.00195 17.3087L3.96862 4.8886C3.91668 4.76033 3.90367 4.61961 3.9312 4.48399C3.95874 4.34838 4.02561 4.22387 4.12346 4.12602C4.22131 4.02817 4.34581 3.9613 4.48143 3.93377C4.61705 3.90623 4.75777 3.91924 4.88604 3.97118Z" fill="url(#paint0_linear_1806_667)" />
      <defs>
        <linearGradient id="paint0_linear_1806_667" x1="19.1866" y1="1.90295" x2="4.68539" y2="19.9575" gradientUnits="userSpaceOnUse">
          <stop offset="0.494463" stopColor="#E43539" />
          <stop offset="1" stopColor="#FF5578" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LocationIconNew;